const ArrowCircleUp = require("./arrow-circle-up.svg").default;
const ArrowCircleDown = require("./arrow-circle-down.svg").default;
const HeroLogo = require("./hero-logo.png").default;
const CloseIcon = require("./close.svg").default;
const RightMark = require("./right-mark.svg").default;
const AngleLeft = require("./angle-left.svg").default;
const AngleRight = require("./angle-right.svg").default;
const AngleDown = require("./angle-down.svg").default;
const Polygon = require("./polygon.svg").default;
const Plus = require("./plus.svg").default;
const Car = require("./car.svg").default;
const CarWhite = require("./car-white.svg").default;
const BathRoom = require("./bathroom.svg").default;
const BathRoomWhite = require("./bathroom-white.svg").default;
const Clint = require("./Clint.jpg").default;
const BedRoom = require("./bedroom.svg").default;
const BedRoomWhite = require("./bedroom-white.svg").default;
const AreaSize = require("./size.svg").default;
const AreaSizeWhite = require("./size-white.svg").default;
const Edit = require("./edit.svg").default;
const ThreeDot = require("./three-dot.svg").default;
const TrashBin = require("./trash-bin.svg").default;
const HelpHeader = require("./help-header.png").default;
const NoImage = require("./no-image.jpg").default;
const ArrowRight = require("./arrow-right.svg").default;
const NotFoundPage = require("./404.svg").default;
const Anz = require("./bank_logo/ANZ.png").default;
const Boq = require("./bank_logo/BOQ.png").default;
const CommonWealth = require("./bank_logo/CommonWealth.png").default;
const Mac = require("./bank_logo/MAC.png").default;
const Nab = require("./bank_logo/NAB.png").default;
const Westpac = require("./bank_logo/Westpac.png").default;
const MenuLeftBackground = require("./background.jpg").default;
const SharingPC = require("./sharing-pc.png").default;
const Privacy = require("./privacy.svg").default;
const Secure = require("./secure.svg").default;
const CrossDevice = require("./sharing-service/cross-device.png").default;
const Residential = require("./sharing-service/residential.svg").default;
const Commercial = require("./sharing-service/commercial.svg").default;
const Equipment = require("./sharing-service/equipment.svg").default;
const Medical = require("./sharing-service/medical.svg").default;
const PrivateFund = require("./sharing-service/private-fund.svg").default;
const PropertyAdvisory = require("./sharing-service/property-advisory.svg").default;
const MinhScreenshot = require("./minh-screenshot.jpg").default;
const IphoneMockup = require("./iphone-mock.png").default;
const StarBox = require("./star-box.svg").default;
const BlueObject = require("./blue-object.svg").default;
const DefaultBrokerImage = require("./default-broker-image.png").default;
const DefaultBottomBrokerImage = require("./default-bottom-broker-image.jpg").default;
// share and super
const AwareSuper = require("./shares-and-super-logos/AwareSuper.png").default;
const CbusSuper = require("./shares-and-super-logos/CbusSuper.png").default;
const Netwealth = require("./shares-and-super-logos/Netwealth.png").default;
const CommSec = require("./shares-and-super-logos/CommSec.png").default;
// awards image
const AwardsABAMortgage =
  require("./awards/ABA_2020_Winner_Commercial_broker_of_the_year.png").default;
const AwardsMortgage = require("./awards/mortgage-award-2020.png").default;
const AwardsTop252020 = require("./awards/top-25-2020.png").default;
const AwardsTop252021 = require("./awards/top-25-2021.png").default;
const WinnerSealFinance = require("./awards/Winner seal__NSW_Best Finance Broker.png").default;
const WinnerSealBroker = require("./awards/Winner seal__NSW_Broker of the Year.png").default;
const ABAFinalistNewCommer = require("./awards/ABA_2020-Finalist_Newcomer of the Year.png").default;
const ABAFinanlistCommercialBroker =
  require("./awards/ABA_2020-Finalist_Commercial Broker of the Year.png").default;
const ABAFinanlistCommercialBroker2021 =
  require("./awards/ABA_2021-Finalist__COMMERCIAL BROKER OF THE YEAR.png").default;
const ABAFinanlistCustomerService =
  require("./awards/ABA_2020-Finalist_Customer Service of the Year.png").default;
const ABAFinanlistOfficeOfTheYear =
  require("./awards/ABA_2021-Finalist__OFFICE OF THE YEAR – NON-FRANCHISE.png").default;
const FinalistSealBestCustomer =
  require("./awards/finalist seal_NSW_Best Customer Service.png").default;
const FinalistSealBestfinance =
  require("./awards/finalist seal_NSW_Best Finance Broker.png").default;
const FinanlistSealBestIndupendent =
  require("./awards/finalist seal_NSW_Best Independent Office.png").default;
const AMAFinalistBrokerOfTheYear =
  require("./awards/AMA20 Finalist Medal_Broker of the Year - Commercial.png").default;
const AMAFinalistBrokerOfTheYearIndependent =
  require("./awards/AMA20 Finalist Medal_Broker of the Year - Independent.png").default;
const AMAFinalistBrokerageOfTheYear =
  require("./awards/AMA20 Finalist Medal_Brokerage of the Year - 6-20 Staff.png").default;
const AMAFinalistBrokerageOfTheYearDiversification =
  require("./awards/AMA20 Finalist Medal_Brokerage of the Year - Diversification.png").default;
const AMAFinalistNewBrokerage =
  require("./awards/AMA20 Finalist Medal_New Brokerage of the Year.png").default;
const FullLogo = require("./full_logo.png").default;
const ArrowUp = require("./arrow-up.svg").default;
const ArrowDown = require("./arrow-down.svg").default;
const GunnLogo = require("./Gunn-logo.svg").default;
const GunnLogoWhite = require("./Gunn-logo-white.svg").default;
const GunnLogoShorten = require("./Gunn-logo-shorten.svg").default;
const WealthXLogoSmall = require("./wealthX_small.png").default;
const PoweredByDomainInsights = require("./PoweredbyDomainInsight_Logo_RGB-GREEN.png").default;
const CdrLogo = require("./cdr-logo.png").default;
const AuGovernmentLogo = require("./au-goverment-logo.png").default;
const WealthXLogo = require("./wealthx_logo.png").default;

export {
  PoweredByDomainInsights,
  Clint,
  ArrowUp,
  ArrowDown,
  CdrLogo,
  AuGovernmentLogo,
  AMAFinalistBrokerageOfTheYear,
  AMAFinalistNewBrokerage,
  AMAFinalistBrokerageOfTheYearDiversification,
  AMAFinalistBrokerOfTheYearIndependent,
  AMAFinalistBrokerOfTheYear,
  FinalistSealBestCustomer,
  FinalistSealBestfinance,
  FinanlistSealBestIndupendent,
  WinnerSealFinance,
  ABAFinalistNewCommer,
  ABAFinanlistCommercialBroker,
  ABAFinanlistCommercialBroker2021,
  ABAFinanlistCustomerService,
  ABAFinanlistOfficeOfTheYear,
  WinnerSealBroker,
  DefaultBrokerImage,
  DefaultBottomBrokerImage,
  BlueObject,
  StarBox,
  IphoneMockup,
  MinhScreenshot,
  Residential,
  Commercial,
  Equipment,
  Medical,
  PrivateFund,
  PropertyAdvisory,
  CrossDevice,
  AwardsABAMortgage,
  AwardsMortgage,
  AwardsTop252020,
  AwardsTop252021,
  Privacy,
  Secure,
  SharingPC,
  MenuLeftBackground,
  Anz,
  Boq,
  CommonWealth,
  Mac,
  Nab,
  Westpac,
  AwareSuper,
  CbusSuper,
  Netwealth,
  CommSec,
  NotFoundPage,
  ArrowRight,
  ArrowCircleUp,
  ArrowCircleDown,
  HeroLogo,
  Car,
  CarWhite,
  CloseIcon,
  RightMark,
  AngleDown,
  AngleLeft,
  AngleRight,
  AreaSize,
  AreaSizeWhite,
  BathRoom,
  BathRoomWhite,
  BedRoom,
  BedRoomWhite,
  ThreeDot,
  TrashBin,
  HelpHeader,
  Edit,
  NoImage,
  Plus,
  Polygon,
  GunnLogo,
  GunnLogoWhite,
  GunnLogoShorten,
  FullLogo,
  WealthXLogoSmall,
  WealthXLogo,
};
